'use client';

import { UpmProductDetailTemplate } from 'ui-components';
import { CommerceCartProvider } from './CommerceCartProvider';
import { UpmProductDetailPageProps } from './types';
import { useUpmProductDetailPage } from './useUpmProductDetailPage';

const UpmProductDetailPageInner = ({
  microcopy,
  ...initialData
}: UpmProductDetailPageProps) => {
  const { data, actions } = useUpmProductDetailPage(initialData);

  return (
    <UpmProductDetailTemplate
      {...data}
      microcopy={microcopy}
      {...actions}
      className="container"
    />
  );
};

export const UpmProductDetailPage = (props: UpmProductDetailPageProps) => {
  if (!props.productSku) {
    return <UpmProductDetailPageInner {...props} />;
  }

  return (
    <CommerceCartProvider>
      <UpmProductDetailPageInner {...props} />
    </CommerceCartProvider>
  );
};
